import React, {useState} from 'react';
import {Container, Icon, IconContainer, LogoIconContainer, LogoIcon} from "./right-sidebar.styles";
import {LanguageMenu, RightMenu} from "../index";
import {useTranslation} from "react-i18next";
import SettingsMenu from "../settings-menu/settings-menu";
import NotificationsMenu from "../notifications-menu/notifications-menu";

const MENUS = {
    LANGUAGE: 'LANGUAGE',
    NOTIFICATION: 'NOTIFICATION',
    SETTING: 'SETTING',
    UN_SELECTED: 'UN_SELECTED',
};

const RightSidebar = () => {

    const [activeMenu, setActiveMenu] = useState(MENUS.UN_SELECTED);
    const [t] = useTranslation();

    const titles = {
        LANGUAGE: t('language'),
        NOTIFICATION: t('notification'),
        SETTING: t('setting')
    }

    return (
        <>
            <Container className='d-flex flex-column align-items-center'>
                <LogoIconContainer>
                    <LogoIcon className="fas fa-th-large"/>
                    <p className='mb-0'>App</p>
                </LogoIconContainer>
                <IconContainer className="d-flex flex-column justify-content-start align-items-center">
                    <button className='simple-btn mb-4' onClick={() => setActiveMenu(MENUS.LANGUAGE)}>
                        <Icon className="fas fa-globe-americas" active={activeMenu === MENUS.LANGUAGE}/>
                    </button>
                    <button className='simple-btn mb-4' onClick={() => setActiveMenu(MENUS.NOTIFICATION)}>
                        <Icon className="fas fa-bell" active={activeMenu === MENUS.NOTIFICATION}/>
                    </button>
                    <button className='simple-btn mb-4' onClick={() => setActiveMenu(MENUS.SETTING)}>
                        <Icon className="fas fa-cog" active={activeMenu === MENUS.SETTING}/>
                    </button>
                </IconContainer>
            </Container>

            <RightMenu title={titles[activeMenu]} active={activeMenu !== MENUS.UN_SELECTED} onCloseMenu={() => setActiveMenu(MENUS.UN_SELECTED)}>
                {
                    activeMenu === MENUS.LANGUAGE &&
                    <LanguageMenu />
                }
                {
                    activeMenu === MENUS.SETTING &&
                    <SettingsMenu />
                }
                {
                    activeMenu === MENUS.NOTIFICATION &&
                    <NotificationsMenu />
                }
            </RightMenu>
        </>
    );
};

export default RightSidebar;
